// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3u-0";
export var eligibilityCardNotEligible = "_3u-1";